import React from 'react';
import Image1 from './image/image1.jpg'
import Image2 from './image/image2.jpg'
import Image3 from './image/image3.jpg'
import Image4 from './image/image4.jpg'
import './clientfeedbackcards.scss'

const ClientFeedbackCards = () => {
	const ClientFeedbackData = [
		{
			id: 1,
			ClientImage: Image1,
			ClientName: "Client Name",
			ClientUsername: "clientusername",
			ClientComment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, quaerat quis? Provident temporibus architecto asperiores nobis maiores nisi a. Quae doloribus ipsum aliquam tenetur voluptates incidunt blanditiis sed atque cumque."
		},
		{
			id: 2,
			ClientImage: Image2,
			ClientName: "Client Name",
			ClientUsername: "clientusername",
			ClientComment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, quaerat quis? Provident temporibus architecto asperiores nobis maiores nisi a. Quae doloribus ipsum aliquam tenetur voluptates incidunt blanditiis sed atque cumque."
		},
		{
			id: 3,
			ClientImage: Image3,
			ClientName: "Client Name",
			ClientUsername: "clientusername",
			ClientComment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, quaerat quis? Provident temporibus architecto asperiores nobis maiores nisi a. Quae doloribus ipsum aliquam tenetur voluptates incidunt blanditiis sed atque cumque."
		},
		{
			id: 4,
			ClientImage: Image4,
			ClientName: "Client Name",
			ClientUsername: "clientusername",
			ClientComment: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem, quaerat quis? Provident temporibus architecto asperiores nobis maiores nisi a. Quae doloribus ipsum aliquam tenetur voluptates incidunt blanditiis sed atque cumque."
		},
	]
	return (
		<>
			<section id="mainClientFeedbackCards">
				<div className="ClientFeedbackCardsTitlebar">
					<h1>Clients Feedback</h1>
				</div>
				<div className="subClientFeedbackCards">
					{
						ClientFeedbackData.map((item, index) => (
							<div className="ClientFeedbackCards" key={index}>
								<div className="ClientFeedbackCards-top">
									<div className="ClientFeedbackCardsProfile">
										<div className="ClientFeedbackCardsImage">
											<img src={item.ClientImage} alt={item.ClientName} />
										</div>
										<div className="ClientFeedbackCardsName">
											<strong>{item.ClientName}</strong>
											<span>@{item.ClientUsername}</span>
										</div>
									</div>
								</div>
								<div className="ClientFeedbackCards-comment">
									<p>{item.ClientComment}</p>
								</div>
							</div>
						))
					}
				</div>
			</section>
		</>
	);
};

export default ClientFeedbackCards;